module.exports = __webpack_public_path__ + "img/Coin.8d5f22a0.png";